import React from "react";
import "./style.css";
import arrowIcon from "../../../../Assets/Icons/iconright-arrow.png";
import fileIcon from "../../../../Assets/Icons/FileIcon.svg";
import audioIcon from "../../../../Assets/Icons/AudioIcon.svg";
import cancelIcon from "../../../../Assets/Icons/cancelIcon.svg";
import saveIcon from "../../../../Assets/Icons/saveIcon.svg";
import plusIcon from "../../../../Assets/Icons/plus-icon.svg";
import backIcon from "../../../../Assets/Icons/back-icon.svg";
import editIcon from "../../../../Assets/Icons/edit-icon-white.svg";

/**
 * Button Type to Styles mapping
 */
const buttonConfig = {
  save: {
    bgColor: "light-green",
    textColor: "white",
    icon: saveIcon,
    iconPosition: "front",
    text: "Save",
    width: "auto",
  },
  apply: {
    bgColor: "light-green",
    textColor: "white",
    icon: saveIcon,
    iconPosition: "front",
    text: "Apply",
    width: "auto",
  },
  send: {
    bgColor: "light-green",
    textColor: "white",
    icon: arrowIcon,
    iconPosition: "back",
    text: "Send",
    width: "auto",
  },
  delete: {
    bgColor: "red",
    textColor: "white",
    icon: null, // No icon by default
    iconPosition: "back",
    text: "Delete",
    width: "auto",
  },
  cancel: {
    bgColor: "light-green",
    textColor: "white",
    icon: null, // No icon by default
    iconPosition: "front",
    text: "Cancel",
    width: "auto",
  },
  cancelWithIcon: {
    bgColor: "red",
    textColor: "white",
    icon: cancelIcon,
    iconPosition: "back",
    text: "Cancel",
    width: "auto",
  },
  cancelWithIconAtFront: {
    bgColor: "red",
    textColor: "white",
    icon: cancelIcon,
    iconPosition: "front",
    text: "Cancel",
    width: "auto",
  },
  file: {
    bgColor: "light-grey",
    textColor: "medium-grey",
    icon: fileIcon,
    iconPosition: "back",
    text: "Add File",
    width: "auto",
  },
  audio: {
    bgColor: "light-grey",
    textColor: "medium-grey",
    icon: audioIcon,
    iconPosition: "back",
    text: "Record Audio",
    width: "auto",
  },
  primary: {
    bgColor: "light-green",
    textColor: "white",
    icon: null,
    iconPosition: "front",
    text: "Send",
    width: "auto",
  },
  addnewrecord: {
    bgColor: "white",
    textColor: "dark-grey",
    icon: plusIcon,
    iconPosition: "front",
    text: "Add New Record",
    width: "auto",
  },
  back: {
    bgColor: "white",
    textColor: "dark-grey",
    icon: backIcon,
    iconPosition: "front",
    text: "Back",
    width: "auto",
  },
  login: {
    bgColor: "green",
    textColor: "white",
    icon: null,
    iconPosition: "front",
    text: "Sign In",
    width: "100",
  },
  edit: {
    bgColor: "light-green",
    textColor: "white",
    icon: editIcon,
    iconPosition: "front",
    text: "Edit Mode",
    width: "auto",
  },
  green: {
    bgColor: "light-green",
    textColor: "white",
    icon: null,
    iconPosition: "front",
    text: "",
    width: "auto",
  },
  grey: {
    bgColor: "light-grey",
    textColor: "dark-grey",
    icon: null,
    iconPosition: "front",
    text: "",
    width: "auto",
  },
};

const Button = ({ btnType, text, onClick, style }) => {
  // Retrieve button configuration based on btnType or use the primary style as the default
  const config = buttonConfig[btnType] || buttonConfig.primary;
  //Create classes for the button based on the type of button
  const buttonClasses = `custom-btn bg-${config.bgColor} text-${config.textColor} width-${config.width}`;

  return (
    <button className={buttonClasses} onClick={onClick} style={style}>
      {/* Icon on the front if available */}
      {config.iconPosition === "front" && config.icon && (
        <img className="custom-btn-icon" alt="button-icon" src={config.icon} />
      )}
      {/* Button Text */}
      {/* Take text from input or config */}
      <div className="custom-btn-text">{text || config.text}</div>
      {/* Icon on the back if available */}
      {config.iconPosition === "back" && config.icon && (
        <img className="custom-btn-icon" alt="button-icon" src={config.icon} />
      )}
    </button>
  );
};

export default Button;
